import images from "../assets/images/*.png";
import videos from "../assets/videos/*.mp4";
import * as utils from "./utils";
import * as data from "../data/data.json";


export function homeView(){
  const contentDom = document.getElementById("content");
  contentDom.innerHTML = "";

  const brandElement = document.createElement('div');
  brandElement.classList.add("brand");

  const appTypeElement = document.createElement('h4');
  appTypeElement.classList.add("brand-text");
  appTypeElement.innerText = "Interactive Story";

  contentDom.innerHTML = "";
  brandElement.appendChild(appTypeElement);

  contentDom.appendChild(brandElement);   
}

export function entryView(){
  const entryDom = document.createElement("div");
  entryDom.id = "entry-wrapper";

  return entryDom; 
}

export function videoView(){
  const scene = localStorage.getItem("currentVideo")
  const contentDom = document.getElementById("content");
  contentDom.innerHTML = "";
  const videoElement = document.createElement('video');
  videoElement.src = videos[scene];
  videoElement.autoplay = true;
  videoElement.controls = true;
  videoElement.muted = false;
  videoElement.width = 320;
  videoElement.controls = false;
  videoElement.classList.add("video-frame");

  const videoWrapperDom = document.createElement('div');
  videoWrapperDom.classList.add("video-wrapper");
  const videoOverlayDom = document.createElement('div');
  videoOverlayDom.classList.add("video-overlay");

  
  const currentVideo = localStorage.getItem("currentVideo");
  videoElement.addEventListener('ended', (event) => {
    if(currentVideo === 'intro'){
      localStorage.setItem('appKey', "time-machine");
      start()
    }
  });

  const interactive = InteractiveDOM();
  if(interactive){
    const {questionDom, optionsDom} = InteractiveDOM();
    if(questionDom && optionsDom){
      videoOverlayDom.appendChild(questionDom);  
      videoOverlayDom.appendChild(optionsDom);    
    }  
    let hasEnded = false;
    videoElement.ontimeupdate = function(e) {
      videoElement.innerHTML = "Play";
      if(!hasEnded){
        const appClient = localStorage.getItem('appKey');
        const currentVideo = localStorage.getItem("currentVideo");
        if(!data[appClient]) return;
        const details = data[appClient][currentVideo];
        if(details){
          const {endAt, atEnd } = details;
          if(videoElement.currentTime >= endAt){
            if(atEnd  === "CONTINUE"){
              utils.submitCompletion();
            };
            questionDom.classList.remove("hidden");
            optionsDom.classList.remove("hidden");
            hasEnded = true;
          } else {
            questionDom.classList.add("hidden");
            optionsDom.classList.add("hidden");
          }        
        }
      } else {
        return;
      }
    };
  }


  const controllerDom = controllerDOM({videoElement});
  videoOverlayDom.appendChild(controllerDom);  

  videoWrapperDom.appendChild(videoElement);  
  videoWrapperDom.appendChild(videoOverlayDom);  
  contentDom.appendChild(videoWrapperDom);  
}

export function pauseplay(videoElement, triggerElement){
  // videoElement.currentTime = videoElement.currentTime + 10
  // return;
  if(videoElement.paused)
  {
    videoElement.play();
    triggerElement.innerHTML = "Pause";
  } else {
    videoElement.pause();
    triggerElement.innerHTML = "Play";
  }
}

export function InteractiveDOM(){  
  const appClient = localStorage.getItem('appKey');
  const currentVideo = localStorage.getItem("currentVideo");
  if(!data[appClient]) return;
  const details = data[appClient][currentVideo];
  if(!details) return;
  const questionDom = document.createElement('div');
  questionDom.classList.add("dialog");
  questionDom.classList.add("on-video");
  questionDom.classList.add("hidden");

  const optionsDom = document.createElement('div');
  optionsDom.classList.add("dialog");
  optionsDom.classList.add("on-video");
  optionsDom.classList.add("hidden");

  const atEnd = details.atEnd;
  switch(atEnd){
    case "OPTIONS":
      const optionNoDom = document.createElement('div');
      optionNoDom.classList.add("dialog-option");
      const noElement = document.createElement("img");
      noElement.src = images[`${currentVideo}_a`];
      noElement.addEventListener('click', (e) => {
        localStorage.setItem("currentVideo", `${currentVideo}_1`);
        videoView()
      })
      optionNoDom.appendChild(noElement)
    
      const optionYesDom = document.createElement('div');
      optionYesDom.classList.add("dialog-option");
      const yesElement = document.createElement("img");
      yesElement.src = images[`${currentVideo}_b`];
      yesElement.addEventListener('click', (e) => {
        localStorage.setItem("currentVideo", `${currentVideo}_2`);
        videoView()
      })
      optionYesDom.appendChild(yesElement)
    
      optionsDom.appendChild(optionNoDom);
      optionsDom.appendChild(optionYesDom);    
      break;
    case "RESTART":
      const restartDom = document.createElement('div');
      restartDom.classList.add("dialog-option");
      const restartWrapper = document.createElement('div');
      restartWrapper.classList.add("result-wrapper");
      const restartHeader = document.createElement('h4');
      const restartMessage = document.createElement('p');
      const restartBtn = document.createElement("button");

      restartHeader.innerHTML = "Oops!"
      restartMessage.innerHTML = "You have to start the story again to select the right choices to move to the next part of the Treasure Hunt.";
      restartBtn.innerHTML = "Restart Checkpoint"

      restartBtn.addEventListener("click", (e) => {
        start();
      });
      restartWrapper.appendChild(restartHeader);
      restartWrapper.appendChild(restartMessage);
      restartWrapper.appendChild(restartBtn);
      restartDom.appendChild(restartWrapper);
      optionsDom.appendChild(restartDom);
      break;
    case "CONTINUE":
      const continueDom = document.createElement('div');
      continueDom.classList.add("dialog-option");
      const continueWrapper = document.createElement('div');
      continueWrapper.classList.add("result-wrapper");
      const continueHeader = document.createElement('h4');
      const continueMessage = document.createElement('p');
      const continueBtn = document.createElement("button");
      const noteDom = document.createElement("p");
      noteDom.classList.add("note");
      noteDom.classList.add("hidden");
      let checkpoint = "";
      if(appClient === "time-machine"){
        checkpoint = "maths-ninja";
        continueHeader.innerHTML = "Well done!"
        continueMessage.innerHTML = "Move on to the checkpoint to continue the next part of the story";
        continueBtn.innerHTML = "Maths Ninja Checkpoint"
        noteDom.innerHTML = "Click to move on";
      } else if (appClient === "maths-ninja"){
        checkpoint = "cleanliness";
        continueHeader.innerHTML = "Well done!"
        continueMessage.innerHTML = "Move on to the checkpoint to continue the next part of the story";
        continueBtn.innerHTML = "Cleanliness Checkpoint"
        noteDom.innerHTML = "Click to move on";
      } else if (appClient === "cleanliness"){
        continueHeader.innerHTML = "Congratulations!"
        continueMessage.innerHTML = "You have found the Missing Gift";
        continueBtn.innerHTML = "The End"
        noteDom.innerHTML = "Click to close";
      }
      noteDom.classList.remove("hidden");
      continueBtn.addEventListener("click", (e) => {
        localStorage.setItem('appKey', checkpoint);
        utils.submitCompletion();
        if (appClient === "cleanliness"){
          homeView();
        } else {
          start();
        }
      });
      continueWrapper.appendChild(continueHeader);
      continueWrapper.appendChild(continueMessage);
      continueWrapper.appendChild(continueBtn);
      continueWrapper.appendChild(noteDom);
      continueDom.appendChild(continueWrapper);
      optionsDom.appendChild(continueDom);
      break;
    default:
      break;
  }


  return {optionsDom, questionDom};
}

export function controllerDOM(objects){
  const controllerDom = document.createElement('div');
  controllerDom.classList.add("dialog-control");
  controllerDom.classList.add("on-video");
  const p2Element = document.createElement("button");
  p2Element.innerHTML = "Play";
  p2Element.addEventListener("click", (e) => {
    pauseplay(objects.videoElement, p2Element)
  });
  const stopBtn = document.createElement("button");
  stopBtn.innerHTML = "Stop";
  stopBtn.addEventListener("click", (e) => {
    homeView()
  });

  objects.videoElement.onended = function(e) {
    p2Element.classList.add("hidden");
  };

  controllerDom.appendChild(stopBtn)
  controllerDom.appendChild(p2Element)
  return controllerDom
}

export function start(){
  const appClient = localStorage.getItem('appKey');
  let startVideo = "intro";
  switch(appClient){
    case "time-machine":
      startVideo = "tm_1";
      break;
    case "maths-ninja":
      startVideo = "mn_1";
      break;
    case "cleanliness":
      startVideo = "cl_1";
      break;
    default:
      break;
  }
  localStorage.setItem('currentVideo', startVideo);
  videoView();
}

